import axios from 'axios';

export function getErrorMessage(error: unknown, fallback: string): string {
  if (error instanceof Error) return error.message;
  return fallback;
}

// Use for errors surfaced directly to the user. Prefers a server-provided message (sent as a
// plain string body) and otherwise returns the localized fallback. Unlike getErrorMessage, it
// never exposes an AxiosError's technical `.message` (e.g. "Request failed with status code 500").
export function getApiErrorMessage(error: unknown, fallback: string): string {
  if (axios.isAxiosError(error) && typeof error.response?.data === 'string') {
    return error.response.data;
  }
  return fallback;
}

// The `code` an API sent with a rejection, when it sent one. A code identifies the kind of
// failure without saying anything in any particular language, so the caller can translate it
// instead of showing the body's own (English) message.
export function getApiErrorCode(error: unknown): string | undefined {
  if (!axios.isAxiosError(error)) return undefined;
  const data: unknown = error.response?.data;
  if (typeof data !== 'object' || data === null) return undefined;
  const code: unknown = (data as { code?: unknown }).code;
  return typeof code === 'string' ? code : undefined;
}

// The HTTP status of a rejected request, or undefined when the error is not an HTTP response
// (network failure, thrown before the request, or not an axios error at all).
export function getHttpStatus(error: unknown): number | undefined {
  return axios.isAxiosError(error) ? error.response?.status : undefined;
}
